import { computed } from 'vue';

/**
 * Composable for computing focal-point object-position styles
 * @param {() => {x: number, y: number}|null|undefined} focalPointGetter - Getter returning the focal point
 * @returns {{ focalPointStyle: import('vue').ComputedRef<object> }}
 */
export function useFocalPoint(focalPointGetter) {
  const focalPointStyle = computed(() => {
    const fp = focalPointGetter();
    if (!fp) return {};
    const x = (fp.x * 100).toFixed(1);
    const y = (fp.y * 100).toFixed(1);
    return { objectPosition: `${x}% ${y}%` };
  });

  return { focalPointStyle };
}
